import React from 'react';
import { useTutorial } from '../../contexts/TutorialContext';
import { CLASS_PRESENTATION_TUTORIAL_ID } from '../../utils/classPresentationTutorialHandoff';
import { broadcastTutorialTabHandoff } from '../../utils/tutorialHandoff';
import {
  TUTORIAL_DESKTOP_ONLY_MESSAGE,
  isTutorialDesktopViewport,
} from '../../utils/tutorialViewport';

const MAIN_PRESENTATION_TUTORIAL_ID = 'main-presentation';

const TAB_BOOTSTRAP_TUTORIAL_IDS = new Set([
  MAIN_PRESENTATION_TUTORIAL_ID,
  CLASS_PRESENTATION_TUTORIAL_ID,
]);

/**
 * `?tutorial=…&tutorialStep=N` 로 열리면 해당 튜토리얼을 시작하고 URL에서 tutorial 파라미터를 제거한다.
 * 원래 탭에 남아 있던 같은 튜토리얼 오버레이는 핸드오프 신호로 닫는다.
 * 지원: main-presentation (대시보드 프레젠), class-presentation (수업 슬라이드 탭)
 */
const PresentationTutorialBootstrap: React.FC = () => {
  const { startTutorial } = useTutorial();
  const startedRef = React.useRef(false);

  React.useEffect(() => {
    if (startedRef.current) return;
    let tutorialId = '';
    let stepIndex: number | undefined;
    try {
      const q = new URLSearchParams(window.location.search);
      tutorialId = (q.get('tutorial') ?? '').trim();
      const rawStep = q.get('tutorialStep');
      if (rawStep != null && rawStep !== '') {
        const n = Number(rawStep);
        if (Number.isFinite(n)) stepIndex = Math.max(0, Math.floor(n));
      }
    } catch {
      return;
    }
    if (!TAB_BOOTSTRAP_TUTORIAL_IDS.has(tutorialId)) return;
    startedRef.current = true;
    const clearTutorialQuery = () => {
      try {
        const url = new URL(window.location.href);
        url.searchParams.delete('tutorial');
        url.searchParams.delete('tutorialStep');
        window.history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);
      } catch {
        /* ignore */
      }
    };
    if (!isTutorialDesktopViewport()) {
      clearTutorialQuery();
      window.alert(TUTORIAL_DESKTOP_ONLY_MESSAGE);
      return;
    }
    broadcastTutorialTabHandoff(tutorialId);
    startTutorial(tutorialId, {
      stepIndex: typeof stepIndex === 'number' ? stepIndex : 0,
    });
    clearTutorialQuery();
  }, [startTutorial]);

  return null;
};

export default PresentationTutorialBootstrap;
